import image1 from './images/image1.png'; // import รูปจากโฟลเดอร์ src

const article =
{
    title: "เว็บพนันออนไลน์อันดับ 1 เล่นง่าย ฝาก-ถอนไว ได้เงินจริง",
    image: image1,
    content: `<h1>(ชื่อเว็บ) เว็บพนันออนไลน์อันดับ 1 เล่นง่าย ฝาก-ถอนไว ได้เงินจริง</h1>
      <p>ยินดีต้อนรับสู่ <strong>(ชื่อเว็บ)</strong>
          เว็บพนันออนไลน์ที่ดีที่สุดในประเทศไทย! เราคือผู้ให้บริการ <strong>คาสิโนออนไลน์</strong>
          <strong>สล็อตออนไลน์</strong> <strong>เกมยิงปลา</strong> และ <strong>แทงบอล</strong>
          ที่มีครบทุกการเดิมพันให้เลือกเล่นในที่เดียว พร้อมระบบ <strong>ฝาก-ถอนออโต้</strong>
          ภายใน 5 วินาที รองรับทั้งการเล่นบน <strong>มือถือ</strong> และ <strong>คอมพิวเตอร์</strong>
          สะดวกสบายทุกที่ทุกเวลา</p>
          <div   style="text-align: center;">
          <img
          src="${image1}" // ใช้ image1 ที่ import มา
          alt="article1_img"
          width="50%"
        />
        </div>
      <h2>ทำไมต้องเลือกเล่นกับ (ชื่อเว็บ)?</h2>
      <ul>
          <li><strong>เว็บตรงไม่ผ่านเอเย่นต์</strong>: ปลอดภัย มั่นคง
              และมีลิขสิทธิ์แท้จากต่างประเทศ 100%</li>
          <li><strong>เกมหลากหลาย</strong>: เลือกเล่นมากกว่า 800 เกมจากค่ายชั้นนำ เช่น
              Sa Gaming, Sexy Baccarat, GDG Casino และอื่น ๆ</li>
          <li><strong>โปรโมชั่นมากมาย</strong>: รับเครดิตฟรีทุกวัน, โบนัสวันเกิด,
              โบนัสเติมเงิน และกิจกรรมเสี่ยงโชคต่าง ๆ</li>
          <li><strong>บริการตลอด 24 ชั่วโมง</strong>:
              ทีมงานคุณภาพพร้อมให้บริการตลอดเวลา</li>
      </ul>
      
      <h2>เล่นง่าย ฝาก-ถอนไว ด้วยระบบอัตโนมัติ</h2>
      <p>ไม่ว่าคุณจะเล่น <strong>สล็อตออนไลน์</strong> <strong>บาคาร่า</strong> หรือ
          <strong>แทงบอล</strong> สามารถทำธุรกรรมได้สะดวกและรวดเร็วผ่านระบบ <strong>ฝาก-ถอนออโต้</strong>
          ที่รองรับทุกเครือข่ายการชำระเงิน ไม่มีขั้นต่ำในการฝากถอน
          คุณสามารถเริ่มเล่นได้ทันที!</p>
      
      <h2>(ชื่อเว็บ) คาสิโนออนไลน์ครบวงจร</h2>
      <p>เราเปิดให้บริการ <strong>คาสิโนออนไลน์</strong> ที่นำเข้าเกมจากต่างประเทศ
          ที่มีทั้ง <strong>บาคาร่า</strong>, <strong>รูเล็ต</strong>, <strong>ไฮโลไทย</strong>,
          <strong>ป๊อกเด้ง</strong>, <strong>น้ำเต้าปูปลา</strong>, <strong>เกมสล็อต</strong>,
          <strong>ยิงปลา</strong> และ <strong>แทงบอลออนไลน์</strong>
          คุณสามารถเล่นได้ตลอด 24 ชั่วโมง พร้อมกับ <strong>สาวสวยสุดเซ็กซี่</strong>
          มาแจกไพ่ให้คุณ</p>
      
      <h2>สมัครสมาชิกกับ (ชื่อเว็บ)</h2>
      <p>อย่าพลาดโอกาสดี ๆ ในการทำเงิน! สมัครสมาชิกกับ <strong>(ชื่อเว็บ)</strong>
          วันนี้ รับโบนัสฟรีทันที พร้อมโปรโมชั่นพิเศษและกิจกรรมสนุก ๆ อีกมากมายจากเรา
          อย่ารอช้า! <strong>(ชื่อเว็บ)</strong> เว็บตรง 100% ที่มาแรงที่สุดในตอนนี้</p>
      
      <h2>ติดต่อเรา</h2>
      <p>หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับการใช้งานเว็บไซต์หรือบริการต่าง ๆ
          สามารถติดต่อทีมงานของเราได้ตลอด 24 ชั่วโมงผ่านช่องทางต่าง ๆ ด้านล่างนี้</p>
      <ul>
          <li>Email: support@example.com</li>
          <li>Phone: 012-345-6789</li>
      </ul>`
}
export default article;
